import { Reveal, SectionLabel } from "../Reveal";
import { ABOUT } from "../../data/content";
import { Check } from "lucide-react";

export const About = () => (
  <section id="about" className="relative py-24 sm:py-32 md:py-40 bg-noise" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-start">
        <div className="md:col-span-5 md:sticky md:top-28">
          <Reveal>
            <div className="relative">
              <img
                src="https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/1ou5wizo_IMG_9093.jpg"
                alt="Ian — REYCRO"
                className="w-full aspect-[4/5] object-cover grayscale contrast-110"
              />
              <div className="absolute -bottom-5 -right-5 bg-[#BAF173] text-black px-6 py-4">
                <p className="font-display text-3xl font-bold leading-none">EST.</p>
                <p className="font-display text-3xl font-bold leading-none">2017</p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="md:col-span-7">
          <SectionLabel>{ABOUT.label}</SectionLabel>
          <Reveal>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-white leading-[0.95]">
              {ABOUT.heading}
            </h2>
          </Reveal>

          <div className="mt-8 space-y-5">
            {ABOUT.paragraphs.map((p, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <p className="text-white/65 text-base sm:text-lg leading-relaxed">{p}</p>
              </Reveal>
            ))}
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-5">
            {ABOUT.pillars.map((pl, i) => (
              <Reveal key={pl.title} delay={i * 0.1}>
                <div className="border border-white/10 bg-[#0A0A0A] p-6 h-full hover:border-[#11E5B4]/40 transition-colors">
                  <h3 className="font-display text-lg font-semibold uppercase tracking-wide text-[#11E5B4] mb-3">{pl.title}</h3>
                  <p className="text-sm text-white/55 leading-relaxed">{pl.text}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {ABOUT.credentials.map((c) => (
                <div key={c} className="flex items-start gap-3" data-testid="credential-item">
                  <Check size={18} className="text-[#BAF173] mt-0.5 shrink-0" />
                  <span className="text-sm text-white/70">{c}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
